import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth';
import { useI18n } from '../i18n';

const API = import.meta.env.VITE_API_URL || 'http://localhost:8000';

let cachedBalance: number | null = null;
const listeners: Array<(b: number) => void> = [];

export function setCoinBalance(b: number) {
  cachedBalance = b;
  listeners.forEach(fn => fn(b));
}

/**
 * Header'da gösterilen küçük coin bakiye chip'i.
 * Giriş yapmamış kullanıcı için görünmez.
 * /wallet sayfasına yönlendirir.
 */
export function CoinChip() {
  const { user, token } = useAuth();
  const { t } = useI18n();
  const [balance, setBalance] = useState<number | null>(cachedBalance);

  useEffect(() => {
    const fn = (b: number) => setBalance(b);
    listeners.push(fn);
    return () => {
      const i = listeners.indexOf(fn);
      if (i >= 0) listeners.splice(i, 1);
    };
  }, []);

  useEffect(() => {
    if (!user || !token) {
      setBalance(null);
      cachedBalance = null;
      return;
    }
    let aborted = false;
    fetch(`${API}/wallet/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        if (aborted || !d) return;
        cachedBalance = d.balance ?? 0;
        setBalance(d.balance ?? 0);
      })
      .catch(() => {});
    return () => { aborted = true; };
  }, [user, token]);

  if (!user) return null;
  if (balance === null) return null;

  return (
    <Link
      to="/magaza"
      className="coin-chip"
      title={t.shopHub.title}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        background: 'linear-gradient(135deg, #f59e0b, #fbbf24)',
        color: '#1a1a1a',
        padding: '4px 10px',
        borderRadius: 999,
        fontWeight: 700,
        fontSize: 13,
        textDecoration: 'none',
        whiteSpace: 'nowrap',
      }}
    >
      <span style={{ fontSize: 14 }}>🪙</span>
      <span>{balance.toLocaleString()}</span>
    </Link>
  );
}
